import { render, staticRenderFns } from "./SensitiveWords.vue?vue&type=template&id=335bced5&scoped=true&"
import script from "./SensitiveWords.vue?vue&type=script&lang=js&"
export * from "./SensitiveWords.vue?vue&type=script&lang=js&"
import style0 from "./SensitiveWords.vue?vue&type=style&index=0&id=335bced5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335bced5",
  null
  
)

export default component.exports